import React, { useState } from 'react';
import { Heart, ArrowRight} from 'lucide-react';
import RoadmapPage from './RoadMapPage';

const App = () => {
  const [showRoadmap, setShowRoadmap] = useState(false);

  return (
    <div className={`min-h-screen ${showRoadmap ? 'bg-black' : 'bg-gradient-to-br from-pink-100 to-red-100'}`}>
      {!showRoadmap ? (
        <LandingPage onContinue={() => setShowRoadmap(true)} />
      ) : (
        <RoadmapPage />
      )}
    </div>
  );
};

const LandingPage = ({ onContinue }) => {
  return (
    <div className="min-h-screen flex flex-col items-center justify-center p-8 text-center">
      <div className="animate-bounce mb-8">
        <Heart className="w-16 h-16 text-red-500" fill="currentColor" />
      </div>
      <h1 className="text-4xl md:text-6xl font-bold text-red-600 mb-6">
        Happy Valentine's Day
      </h1>
      <p className="text-xl md:text-2xl text-red-400 mb-8 max-w-2xl">
        To the one who makes my heart skip a beat... I've prepared something special just for you.
      </p>
      <button
        onClick={onContinue}
        className="group flex items-center gap-2 bg-red-500 hover:bg-red-600 text-white px-8 py-4 rounded-full text-lg transition-all transform hover:scale-105"
      >
        Continue to Our Journey
        <ArrowRight className="group-hover:translate-x-2 transition-transform" />
      </button>
    </div>
  );
};

export default App;
